import React from "react";
import TagElement from "../tag-element/tag-element.tsx";
import RaindropMotionBouncePop from "../raindrop-motion-bounce-pop/raindrop-motion-bounce-pop.tsx";

const TagElementMotion = ({ value, onClick = () => {}, index = 0 }) => {
  return (
    <RaindropMotionBouncePop delay={index * 0.1}>
      <TagElement value={value} onClick={onClick} />
    </RaindropMotionBouncePop>
  );
};

export default TagElementMotion;
